import { REHYDRATE } from "redux-persist/lib/constants";
import { constants } from "../constants/redux-constants";

const initialState = {
  tabValues: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REHYDRATE:
      return {
        ...state,
        ...(action.payload?.tabui || {}),
      };
    case constants.RESET:
      return {
        ...initialState,
      };
    case constants.TAB.UPDATE_TAB_VALUE:
      let tabValuesData = structuredClone(state.tabValues);
      let tabIdx = tabValuesData.findIndex(
        (f) => f.module === action.payload.module
      );
      if (tabIdx > -1) {
        tabValuesData[tabIdx]["tabValue"] = action.payload.tabValue;
      } else {
        tabValuesData.push({
          tabValue: action.payload.tabValue,
          subtabValue: 0,
          module: action.payload.module,
        });
      }
      tabValuesData = tabValuesData.filter(
        (f) => f.module === action.payload.module
      );
      return {
        ...state,
        tabValues: structuredClone(tabValuesData),
      };
    case constants.TAB.UPDATE_SUBTAB_VALUE:
      let subtabValuesData = structuredClone(state.tabValues);
      let subtabIdx = subtabValuesData.findIndex(
        (f) => f.module === action.payload.module
      );
      if (subtabIdx > -1) {
        tabValuesData[subtabIdx]["tabValue"] = action.payload.tabValue;
      }
      return {
        ...state,
        subtabValue: structuredClone(subtabValuesData),
      };
    default:
      return {
        ...state,
      };
  }
};
